import type { FormGroup, ValidationErrors } from '@angular/forms';

export function workModelValidator(control: FormGroup): ValidationErrors | null {
  const remote = !!control.get('remote')?.value;
  const onSite = !!control.get('onSite')?.value;
  const hybrid = !!control.get('hybrid')?.value;

  const isValid = [remote, onSite, hybrid].some(isSelected => isSelected);

  return isValid ? null : { workModel: true };
}
